import aluminumJSON from '../../../data/aluminum.json' with { type: 'json' };
import { enrichDataWithLinks } from '../../../common/link-resolver.js';

export async function loadAluminumData() {
  return enrichDataWithLinks(structuredClone(aluminumJSON), { useAluminumFallback: true });
}
